import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFileUrl } from "../../utils/GetAuthUser";
import { createSelector } from "@reduxjs/toolkit";
import { Link } from "react-router-dom";
import { getUserListThunk as onGetUserListThunk } from "../../slices/artists/thunk";
import { getRole } from "../../utils/GetRole";

const ArtistComponent = () => {
  
  const dispatch = useDispatch();

  const fileUrl = getFileUrl();
  const defaultImage = "/default.png";

  const [role]  = useState(getRole);
  
  const selecArtistState = (state) => state.user;
  const artistSelector = createSelector(selecArtistState, (artist) => ({
    isLoading: artist.isLoading,
    users: artist.users,
  }));

  const { users, isLoading } = useSelector(artistSelector);

  useEffect(() => {
    dispatch(onGetUserListThunk({ userType: 2 }));
  }, [dispatch]);

  const artistData =
    users?.map((user) => ({
      id: user.id,
      name: user.name,
      userType: user.skill?.[0] || " ",
      image: user.image ? `${fileUrl}/${user.image}` : null,
    })) || [];
  return (
    <>
      <div className="w-full  xl:max-w-[30%] xl:min-w-[23%] border border-border_color rounded-[14px]">
        {/* Header */}
        <div className="flex items-center justify-between p-3">
          <div>
            <span className="text-[22px] text-black font-bold font-grotesk">
              Artists
            </span>
          </div>
          <div>
            <Link
              to={role === "admin" ? "/admin/artists" : "/artist/artist-list"}
              className="border border-border_color rounded-[10px] py-3 px-5 text-xs font-bold font-grotesk text-secondary"
            >
              View all
            </Link>
          </div>
        </div>
        <hr className="mt-3" />

        {/* Scrollable List */}

        <div
          className="overflow-y-auto px-2 scrollbar-hide"
          style={{ maxHeight: "calc(65vh - 93px)" }}
        >
          {isLoading
            ? Array.from({ length: 8 }).map((_, index) => (
                <div
                  key={index}
                  className="w-full flex items-center justify-between border-b border-border_color py-2"
                >
                  {/* Left Side Skeleton */}
                  <div className="flex items-center gap-2 w-full">
                    <div className="w-10 h-10 rounded-full bg-gray-200 animate-pulse" />
                    <div className="flex flex-col gap-1 w-[60%]">
                      <div className="h-3 w-32 bg-gray-200 rounded animate-pulse" />
                      <div className="h-3 w-24 bg-gray-200 rounded animate-pulse" />
                    </div>
                  </div>

                  {/* Right Side Skeleton */}
                  <div className="w-20 h-4 bg-gray-200 rounded animate-pulse" />
                </div>
              ))
            : artistData.map((user, index) => (
              <div
                key={index}
                className="w-full flex items-center justify-between border-b border-border_color py-[19px]"
              >
                {/* Left Side */}
                <div className="flex items-center gap-2">
                  {/* Profile Pic */}
                  <div className="w-10 h-10 border-2 rounded-full overflow-hidden">
                    <img
                      src={user.image || defaultImage}
                      alt={user.name}
                      className="w-full h-full object-cover"
                    />
                  </div>

                  {/* User Info */}
                  <div>
                    <div className="flex flex-col items-start">
                      <p className="text-[12px] sm:text-[14px] text-black font-bold font-grotesk">
                        {user.name}
                      </p>
                      <p className="text-[10px] sm:text-sm text-lable_color font-medium font-grotesk">
                        {user.userType}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Right Side */}
                <div>
                  <Link
                    to={
                      role === "admin"
                        ? `/admin/artist-profile/${user.id}`
                        : `/artist/profile/${user.id}`
                    }
                    className="text-[12px] text-secondary font-bold font-grotesk underline"
                  >
                    See Profile
                  </Link>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default ArtistComponent;
